import React, { useState } from 'react';
import { UserAvatar } from '../basic/UserAvatar';
import { TrendingAuthorsType } from './TrendingAuthors.types';
import { shortenName } from '../../../helpers/shortenName';
import AuthorLayout from '../NewAuthors/AuthorLayout';
import FollowButton from '../basic/FollowButton';
import { getUserId } from '../../../lib/jwt';

export default function TrendingAuthor({
  author,
  rightAlign
}: {
  author: TrendingAuthorsType;
  rightAlign: boolean;
}) {
  const [showAuthorLayout, setShowAuthorLayout] = useState(false);
  const [followCount, setFollowCount] = useState(author.followers_count);

  const onUpdateFollowersCount = (followingId: number, followed: boolean) => {
    // Update the followers_count of the NewAuthor with the new value
    followed ? setFollowCount(followCount + 1) : setFollowCount(followCount - 1);
  };

  return (
    <div
      className="overflow-visible h-28 relative hover:z-20"
      onMouseEnter={() => setShowAuthorLayout(true)}
      onMouseLeave={() => setShowAuthorLayout(false)}
    >
      <div>
        <UserAvatar className="w-20 h-20" user={author.user} />
        <p className="text-center sm:text-sm ssm:text-xs mt-2">
          {shortenName(author.user.username)}
        </p>
      </div>
      {showAuthorLayout ? (
        <AuthorLayout
          classname={`flex h-28 w-72 bg-gray-blueish-dark z-0 items-center rounded-lg absolute top-28 ${
            rightAlign ? '-left-52' : 'left-0'
          }`}
          item={author}
          followCount={followCount}
        >
          {author.user_id !== getUserId() && (
            <FollowButton
              user={author.user}
              onUpdateFollowersCount={onUpdateFollowersCount}
            />
          )}
        </AuthorLayout>
      ) : (
        <div />
      )}
    </div>
  );
}
